export default __webpack_public_path__ + "static/media/meals.ae088d0f.png";